import { styled } from "styled-components";

export const RegularInfo = styled.p`
  color: #949494;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
